import Alert from '../components/alert';
import React from 'react';

const texts = {
  member:  'can add contacts, send/receive messages, view metrics, receive notifications.',
  manager: 'can do the same, managers can also import files, view additional metrics.',
  admin:   'can do anything member/manager can do, also add/remove users, change account settings.'
};


export default function RolesInfo({ roles }) {
  const info = Object.entries(roles)
    .map(([ role, label ], index, allRoles) => (
      <div className={allRoles.length > index + 1 ? 'margin-bottom' : null} key={role}>
        <b>{label}</b>&nbsp;{texts[role]}
      </div>
    ));

  return (
    <Alert><div>{info}</div></Alert>
  );
}
